import React from "react";
import {Button, Row, Col} from "react-bootstrap";
import Component from "../../components/AscComponent";
import CommonTable from "../Elements/Table/CommonTable";
import CategoryDeleteModal from "./CategoryDeleteModal";
import CategoryInsertModal from "./CategoryInsertModal";
import CategoryUpdateModal from "./CategoryUpdateModal";
import CategoryReadModal from "./CategoryReadModal";

export default class Category extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // table item
            columns: this.getColumnsData(),
            data: [],
            pages: null,
            loading: false,
            filtered: [],
            sorted: [{id: "id", desc: true}],

            // modal item
            show: false,
            modalType: null,
            selectedData: [],

            // form data
            name: "",
            explanation: "",
            rgb: "",
            font_rgb: "",
            backgroundDefaultColor: "#ED7C47",
            backgroundPresetOptions: ['#C2C2C1','#CD8A96','#E7475D','#E272BB','#A486F5','#4479E6',
                '#00AEFF','#469FBC','#50A66B','#AAB95D','#F3B15A','#ED7C47'],
            fontDefaultColors: "#ffffff",
            fontPresetOptions: ["#ffffff","#000000"],
            rgb_picker: false,
            font_rgb_picker: false
        };
    }

    /**
     * 一覧表作成
     */
    getColumnsData() {
        return [
            {
                Header: this.props.langText.Body.Title,
                accessor: "name",
            }, {
                Header: this.props.langText.Body.Content,
                accessor: "categorize.explanation",
                Cell: data => {
                    if (data && data.row && data.row.original && data.row.original.categorize && data.row.original.categorize.explanation) {
                        return data.row.original.categorize.explanation;
                    } else {
                        return "";
                    }
                }
            }, {
                Header: this.props.langText.Body.CategoryImage,
                accessor: "rgb",
                Cell: data => {
                    if (data && data.row && data.row.original) {
                        return (
                            <span
                                style={{
                                    backgroundColor: data.row.original.rgb,
                                    padding: '2px 4px',
                                    borderRadius: '4px',
                                    color: data.row.original.font_rgb,
                                    marginRight: '5px'
                                }}
                            >
                                {data.row.original.name}
                            </span>
                        );
                    } else {
                        return "";
                    }
                }
            }
        ]
    }

    /**
     * モーダル表示分岐
     */
    getModalBranch() {
        switch (this.state.modalType) {
            case "insert":
                return (
                    <CategoryInsertModal
                        onHide={() => this.setState({show: false})}
                        onClick = {this.onClickHandle}
                        validationHandle = {this.validationHandle}
                        state={this.state}
                        onTextChange={this.onTextChange}
                        onFileChange={this.onFileChange}
                        langText={this.props.langText}
                        propSetState = {this.propSetState}
                        charaLimit = {this.props.charaLimit}
                        onTextChange_Limit = {this.onTextChange_Limit}
                    />
                );
            case "update":
                return (
                    <CategoryUpdateModal
                        onHide={() => this.setState({show: false})}
                        onClick = {this.onClickHandle}
                        validationHandle = {this.validationHandle}
                        state={this.state}
                        onTextChange={this.onTextChange}
                        onFileChange={this.onFileChange}
                        langText={this.props.langText}
                        propSetState = {this.propSetState}
                        charaLimit = {this.props.charaLimit}
                        onTextChange_Limit = {this.onTextChange_Limit}
                    />
                );
            case "delete":
                return (
                    <CategoryDeleteModal
                        onHide={() => this.setState({show: false})}
                        onClick = {this.onClickHandle}
                        validationHandle = {this.validationHandle}
                        state={this.state}
                        langText={this.props.langText}
                        propSetState = {this.propSetState}
                    />
                );
            case "read":
                return (
                    <CategoryReadModal
                        onHide={() => this.setState({show: false})}
                        onClick = {this.onClickHandle}
                        validationHandle = {this.validationHandle}
                        state={this.state}
                        langText={this.props.langText}
                        propSetState = {this.propSetState}
                    />
                );
            default:
                return null;
        }
    }

    /**
     * モーダル表示
     */
    modalShow = (modalType) => async event => {
        let { selectedData } = this.state;
        event.preventDefault();
        let rowInfo = '';
        //ひとつだけ選択して編集または削除ボタンを押した場合
        if (modalType === "update" || modalType === "read" || (modalType === "delete" && selectedData.length === 1)) {
            rowInfo = selectedData.slice().pop();
        } 
        //編集・削除の場合一つ以上の項目選択必須
        if((modalType === "update" || modalType === "read" || modalType === "delete" ) && selectedData.length === 0){
            return this.showErrorObjectMessage('ModalSelectError');
        }
        //編集場合一つの項目だけ選択可能
        if((modalType === "update" || modalType === "read") && selectedData.length > 1){
            return this.showErrorObjectMessage('UpdateModalSelectError');
        }

        let setData = {
            id: rowInfo && rowInfo.id
                ? rowInfo.id
                : 0,
            name: rowInfo && rowInfo.name
                ? rowInfo.name
                : "",
            explanation: rowInfo && rowInfo.categorize && rowInfo.categorize.explanation
                ? rowInfo.categorize.explanation
                : "",
            rgb: rowInfo && rowInfo.rgb
                ? rowInfo.rgb
                : this.state.backgroundDefaultColor,
            font_rgb: rowInfo && rowInfo.font_rgb
                ? rowInfo.font_rgb
                : this.state.fontDefaultColors,
            modalType: modalType,
            show: true
        }

        if(modalType === "delete"){
            setData.id = selectedData.map(row=>row.id);
            setData.name = selectedData.map(row=>row.name);
        }

        this.setState(setData);
    };

    /**
     * 各画面先でのボタン押下時の動作内容
     */
    onClickHandle = modalType => async () => {
        let {
            id,
            name,
            explanation,
            rgb,
            font_rgb
        } = this.state;

        try {
            switch (modalType) {
                case 'insert':
                    this.blockUI();
                    await this.ascAxios('post', `${this.reactContainerPath}/insert`, {
                        name,
                        explanation,
                        rgb,
                        font_rgb
                    });
                    alert(this.props.langText.Message.DataInsertSuccess);
                    this.reactTableRefresh(true);
                    break;
                case 'update':
                    this.blockUI();
                    await this.ascAxios('post', `${this.reactContainerPath}/update`, {
                        id,
                        name,
                        explanation,
                        rgb,
                        font_rgb
                    });
                    alert(this.props.langText.Message.DataUpdateSuccess);
                    this.reactTableRefresh(true);
                    break;
                case 'delete':
                    this.blockUI();
                    await this.ascAxios('post', `${this.reactContainerPath}/delete`, {
                        id
                    });
                    alert(this.props.langText.Message.DataDeleteSuccess);
                    this.reactTableRefresh(true);
                    break;
                default:
                    this.showErrorObjectMessage('ModalTypeError');
            }
        } catch (err) {
            console.error(err);
            this.showErrorObjectMessage(err);
        } finally {
            this.setState({show: false});
        }
    };

    /**
     * 各画面のボタン押下条件
     */
    validationHandle = (param) => {
        let validation_flag = false;
        let {
            id,
            name,
            explanation,
            rgb,
            font_rgb
        } = this.state;

        switch (param) {
            case "insert":
            case "update":
                validation_flag = !!(name && explanation && rgb && font_rgb);
                break;
            case "delete":  
                validation_flag = !!(id);
                break;
            case "read":
                validation_flag = !!(id);
                break;
            default:
                break;
        }
        
        return validation_flag;
    };

    render() {
        return (
            <div className="Category">
                {/*一覧画面*/}
                <Row>
                    <Col xs={12} md={12}>
                        <Button
                            id = "categories-insert"
                            className = "table-button"
                            variant = "default"
                            size = "sm"
                            onClick={this.modalShow("insert")}
                            hidden={!this.props.currentPermission.create}
                        >
                            {this.props.langText.Body.InsertTitle}
                        </Button>
                        <Button
                            id = "categories-update"
                            className = "table-button"
                            variant = "default"
                            size = "sm"
                            onClick={this.modalShow("update")}
                            hidden={!this.props.currentPermission.update}
                        >
                            {this.props.langText.Body.UpdateTitle}
                        </Button>
                        <Button
                            id = 'categories-read'
                            className = 'table-button'
                            variant = 'default'
                            size = 'sm'
                            onClick={this.modalShow('read')}
                            hidden={!!this.props.currentPermission.update}
                        >
                            {this.props.langText.Body.ReadTitle}
                        </Button>
                        <Button
                            id = "categories-delete"
                            className = "table-button"
                            variant = "default"
                            size = "sm"
                            onClick={this.modalShow("delete")}
                            hidden={!this.props.currentPermission.delete}
                        >
                            {this.props.langText.Body.DeleteTitle}
                        </Button>
                    </Col>
                    <Col xs={12} md={12}>
                        <CommonTable
                            showPageSize={true}
                            showCheckbox={true}
                            showPagination={true}
                            propsPageIndex = {this.state.pageIndex? this.state.pageIndex: 0}
                            state = {this.state}
                            tableHeight={this.props.tableHeight}
                            tbodyHeight={this.props.tableHeight-30}
                            columns={this.state.columns}
                            data={this.state.data}
                            loading={this.state.loading}
                            onFetchData={this.fetchData}
                            filtered={this.state.filtered}
                            sorted={this.state.sorted}
                            pageCount = {this.state.pageCount}
                            manual = {true}
                            langText = {this.props.langText.Table}
                            className="category-table"
                        />
                    </Col>
                </Row>
                {/*モーダル表示分岐*/}
                {this.getModalBranch()}
            </div>
        );
    }
} 